'use client';

import { useUser } from '@/components/providers/user-provider';
import { TabNavigation } from '@/components/tab-navigation';
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from '@/components/ui/extended/sheet';
import { useEffect, useState } from 'react';
import { profileTabs } from '../utils/constants';
import { BasicDetails } from './basic-details';
import { OtherSection } from './other-section';
import { PurchasedBatches } from './purchased-batches';
import { ReferralDashboard } from './referral-dashboard';
export function ProfileSheet() {
  const [isOpen, setIsOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('Referrals');
  const {
    user
  } = useUser();
  const [firstLetter, setFirstLetter] = useState('');
  useEffect(() => {
    if (user?.name) {
      setFirstLetter(user?.name.charAt(0).toUpperCase());
    }
  }, [user]);
  useEffect(() => {
    const handleOpenProfileSheet = (event: CustomEvent) => {
      setIsOpen(true);
      if (event.detail?.activeTab) {
        setActiveTab(event.detail.activeTab);
      }
    };
    window.addEventListener('open-profile-sheet', handleOpenProfileSheet as EventListener);
    return () => {
      window.removeEventListener('open-profile-sheet', handleOpenProfileSheet as EventListener);
    };
  }, []);
  const renderAvatar = () => {
    return <div className="flex size-[35px] items-center justify-center rounded-full text-xl font-semibold " style={{
      backgroundColor: 'hsl(85, 70%, 80%)',
      color: 'rgba(0,0,0,0.7)'
    }} data-sentry-component="renderAvatar" data-sentry-source-file="profile-sheet.tsx">
        {firstLetter}
      </div>;
  };
  const handleTabClick = (tab: string) => {
    setActiveTab(tab);
  };
  return <Sheet open={isOpen} onOpenChange={setIsOpen} data-sentry-element="Sheet" data-sentry-component="ProfileSheet" data-sentry-source-file="profile-sheet.tsx">
      <SheetTrigger asChild data-sentry-element="SheetTrigger" data-sentry-source-file="profile-sheet.tsx">
        <button type="button" className="hidden w-[35px] border-0 bg-transparent p-0 md:block">
          {renderAvatar()}
        </button>
      </SheetTrigger>
      <SheetContent data-sentry-element="SheetContent" data-sentry-source-file="profile-sheet.tsx">
        <SheetTitle data-sentry-element="SheetTitle" data-sentry-source-file="profile-sheet.tsx">
          <div className="hidden w-full flex-wrap items-center gap-4 overflow-hidden whitespace-nowrap rounded-t-lg bg-white px-6 py-4 text-2xl font-semibold max-md:max-w-full max-md:px-5 md:flex">
            <div className="my-auto flex-1 shrink basis-0 self-stretch">
              Profile
            </div>
            <button type="button" onClick={() => setIsOpen(!isOpen)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13" fill="none" data-sentry-element="svg" data-sentry-source-file="profile-sheet.tsx">
                <path fillRule="evenodd" clipRule="evenodd" d="M13.1488 0.35247C13.5068 0.71045 13.5068 1.29085 13.1488 1.64883L2.14883 12.6488C1.79085 13.0068 1.21045 13.0068 0.85247 12.6488C0.494489 12.2909 0.494489 11.7104 0.85247 11.3525L11.8525 0.35247C12.2104 -0.00551079 12.7909 -0.00551079 13.1488 0.35247Z" fill="#586676" data-sentry-element="path" data-sentry-source-file="profile-sheet.tsx" />
                <path fillRule="evenodd" clipRule="evenodd" d="M0.85247 0.35247C1.21045 -0.00551079 1.79085 -0.00551079 2.14883 0.35247L13.1488 11.3525C13.5068 11.7104 13.5068 12.2909 13.1488 12.6488C12.7909 13.0068 12.2104 13.0068 11.8525 12.6488L0.85247 1.64883C0.494489 1.29085 0.494489 0.71045 0.85247 0.35247Z" fill="#586676" data-sentry-element="path" data-sentry-source-file="profile-sheet.tsx" />
              </svg>
            </button>
          </div>
        </SheetTitle>
        <div className="mb-2 hidden h-[calc(100vh-12vh)] overflow-y-scroll rounded-b-2xl bg-x-background scrollbar-none md:block md:w-[460px] 2xl:w-[600px]">
          <TabNavigation tabs={profileTabs} activeTab={activeTab} onClick={handleTabClick} className="sticky top-20 z-10 md:static" data-sentry-element="TabNavigation" data-sentry-source-file="profile-sheet.tsx" />
          {activeTab === 'Referrals' && <ReferralDashboard />}
          {activeTab === 'Basic details' && <BasicDetails />}
          {activeTab === 'My batches' && <PurchasedBatches onClose={() => setIsOpen(false)} />}
          {activeTab === 'Others' && <OtherSection onClose={() => setIsOpen(false)} />}
        </div>
      </SheetContent>
    </Sheet>;
}
ProfileSheet.displayName = 'ProfileSheet';